var React = require('react');

function RupeeSign (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M320 144v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h288a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 44v40a12 12 0 0 1-12 12h-76.26a144 144 0 0 1-114.87 223.91l150.88 139.27a12 12 0 0 1-8.14 20.82h-82.56a12 12 0 0 1-8.14-3.18L3.86 324.46A12 12 0 0 1 0 315.64v-48A12 12 0 0 1 9.13 256H96a79.68 79.68 0 0 0 31.39-6.4 68.32 68.32 0 0 0 6.21-3 80 80 0 0 0-4.83-143.6 71.06 71.06 0 0 0-31.52-7.28H12a12 12 0 0 1-12-12V44a12 12 0 0 1 12-12h296a12 12 0 0 1 12 12z","className":"fa-primary","key":2})]);
}

RupeeSign.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = RupeeSign;

RupeeSign.default = RupeeSign;
